import { render } from "./VitrineFilters.vue?vue&type=template&id=2ae3eb37"
import script from "./VitrineFilters.vue?vue&type=script&lang=js"
export * from "./VitrineFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__